import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";

import { fetchBrainstormIdea } from "modules/collaboration/api/brainstorming";

import { BrainstormIdea } from "modules/collaboration/types/entities";

type SingleBrainstormIdeaQueryKey = [string, { id: string }];

export const SINGLE_BRAINSTORM_IDEA_QUERY_KEY = "/brainstorm_ideas/:id";

export const getSingleBrainstormIdeaQueryKey = (
  id: string
): SingleBrainstormIdeaQueryKey => [SINGLE_BRAINSTORM_IDEA_QUERY_KEY, { id }];

export const useSingleBrainstormIdeaQuery = (
  id: string,
  options: UseQueryOptions<
    BrainstormIdea,
    AxiosError,
    BrainstormIdea,
    SingleBrainstormIdeaQueryKey
  > = {}
) => {
  return useQuery<
    BrainstormIdea,
    AxiosError,
    BrainstormIdea,
    SingleBrainstormIdeaQueryKey
  >({
    queryKey: getSingleBrainstormIdeaQueryKey(id),
    queryFn: ({ queryKey: [, { id }] }) => fetchBrainstormIdea({ id }),
    enabled: !!id,
    ...options
  });
};
